import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Box, Chip, Tooltip } from '@material-ui/core'

import { TableRow, TableCell } from 'components/Table'
import { MenuButton } from 'components'
import ActionButtons from '../ActionButtons'
import constants from 'constants/index'
import helpers from 'helpers'
import useStyles from './styles'

const PaymentServiceTemplatesTableRow = ({
  paymentServiceTemplate,
  refresh = () => {},
}) => {
  const classes = useStyles()

  const deadline = () => {
    if (!paymentServiceTemplate?.recommendedDeadlineValue) return '-'

    const period = constants.paymentServiceTemplate.PERIOD_OPTIONS.find(
      (option) =>
        option.id === paymentServiceTemplate?.recommendedDeadlinePeriod,
    )

    const recommendedDeadlineValue =
      paymentServiceTemplate?.recommendedDeadlineValue

    return `${recommendedDeadlineValue} ${period?.name || ''}`
  }

  return (
    <TableRow>
      <TableCell align="left">{paymentServiceTemplate?.id}</TableCell>
      <TableCell disableTooltip noOverFlow align="left">
        <Box display="flex" alignItems="center">
          <Tooltip title={paymentServiceTemplate?.name || ''}>
            <span className={classes.name}>{paymentServiceTemplate?.name}</span>
          </Tooltip>
          {paymentServiceTemplate?.isGovernanceReviewType && (
            <Chip
              size="small"
              variant="outlined"
              label="Revisão"
              className={classes.reviewChip}
            />
          )}
        </Box>
      </TableCell>
      <TableCell align="center">
        R$ {helpers.formatters.currencyInput(paymentServiceTemplate?.price)}
      </TableCell>
      <TableCell align="center">{deadline()}</TableCell>
      <TableCell disableTooltip align="center">
        <Chip
          className={clsx(classes.root, {
            [classes.active]: paymentServiceTemplate?.active,
            [classes.inactive]: !paymentServiceTemplate?.active,
          })}
          size="small"
          label={paymentServiceTemplate?.active ? 'Ativo' : 'Inativo'}
        />
      </TableCell>
      <TableCell disableTooltip align="right">
        <MenuButton>
          <ActionButtons
            paymentServiceTemplate={paymentServiceTemplate}
            refresh={refresh}
          />
        </MenuButton>
      </TableCell>
    </TableRow>
  )
}

PaymentServiceTemplatesTableRow.propTypes = {
  paymentServiceTemplate: PropTypes.object,
  refresh: PropTypes.func,
}

export default PaymentServiceTemplatesTableRow
